

import React, { useState, useEffect,useRef } from "react";
import axios from "axios";
import "./Exam.css";
import { useNavigate, useLocation } from "react-router-dom";

// Components
import ExamHeader from "./ExamHeader";
import ExamQuestionCard from "./ExamQuestionCard";
import QuestionNavigator from "./QuestionNavigator";
import ProgressOverview from "./ProgressOverview";
import SubmitExamDialog from "./SubmitExamDialog";
import ExamResults from "./ExamResults";
import MainLayout from "../MainLayout";
import config from "../config";
import ConnectionLostDialog from "./ConnectionLostDialog";
import {
  savePendingAnswer,
  removePendingAnswer,
  getPendingAnswers,
  getPendingCount,
  clearPendingAnswers
} from "./pendingAnswerService";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from "@mui/material";
import CloseAssessmentDialog from "./CloseAssessmentDialog";




const isTruthyConfigValue = (value) => {
  if (value === true || value === 1) return true;
  if (value && typeof value === "object" && "value" in value) {
    return isTruthyConfigValue(value.value);
  }
  if (typeof value === "string") {
    return ["true", "1", "yes", "y"].includes(value.trim().toLowerCase());
  }
  return false;
};

const unwrapExamData = (source) => {
  if (!source || typeof source !== "object") return source;

  return source.examData || source.data || source.result || source;
};

const getExamDurationMinutes = (source) => {
  if (!source || typeof source !== "object") return 0;

  const rawDuration =
    source.duration ??
    source.duration_min ??
    source.exam_duration ??
    source.exam?.["Duration(min)"] ??
    source.exam?.Duration ??
    source.exam?.duration;

  const duration = Number(rawDuration);
  return Number.isFinite(duration) ? duration : 0;
};

// const fetchBackNavigationRequired = async () => {
//   try {
//     const response = await axios.get("/employee/exam-config/", {
//       withCredentials: true,
//     });

//     return isTruthyConfigValue(response.data?.backNavigationRequired);
//   } catch (error) {
//     console.error("[Exam] Failed to fetch exam config:", error);
//     return false;
//   }
// };



const fetchBackNavigationRequired = async () => {
  try {
    const response = await axios.get("/employee/exam-config/", {
      withCredentials: true,
    });

    const value =
      response.data?.backNavigationRequired ??
      response.data?.data?.["Assessment Controls"]?.[
        "Back Navigation Required"
      ]?.value;

    return isTruthyConfigValue(value);
  } catch (error) {
    console.error("[Exam] Failed to fetch exam config:", error);
    return false;
  }
};

export default function ExamPortal() {
  const [showInstructions, setShowInstructions] = useState(false);
  const [exam, setExam] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [status, setStatus] = useState([]);
  const [currentQ, setCurrentQ] = useState(0);
  const [timeLeft, setTimeLeft] = useState(0);
  const [usedTime, setUsedTime] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [showSubmitModal, setShowSubmitModal] = useState({ open: false, isAuto: false, autoReason: null });
  const [examEmployeeId, setExamEmployeeId] = useState(null);
  const [webSocket, setWebSocket] = useState(null);
  const [examid, setexamId] = useState(0)
  const [unansweredMandatoryCount, setUnansweredMandatoryCount] = useState(0);
  // Proctoring / Violations
  const [violationCount, setViolationCount] = useState(0);
  const [examStatus, setExamStatus] = useState("Start");
  const [backNavigationRequired, setBackNavigationRequired] = useState(false);

  // Violation Alert UI
  const [violationAlertOpen, setViolationAlertOpen] = useState(false);
  const [violationMessage, setViolationMessage] = useState("");
  const [lastViolationType, setLastViolationType] = useState("");
  const [connectionLost, setConnectionLost] = useState(false);
  const [syncStatus, setSyncStatus] = useState({});
  const [mongoSyncFailed, setMongoSyncFailed] = useState(false);
  const [retrying, setRetrying] = useState(false);
  const [showCloseConfirm, setShowCloseConfirm] = useState(false);

  const maxViolations = 3;
  const ackTimers = React.useRef({});
  // const reconnectTimer = React.useRef(null);
  const lastViolationAt = React.useRef(0);
  const isAwayFromAssessment = React.useRef(false);
  const isViolationPopupOpen = React.useRef(false);
  const autoSubmitTriggered = React.useRef(false);
  const timeUpPersisted = React.useRef(false);
  const webSocketRef = React.useRef(null);
  const wsRef = useRef(null);
const reconnectTimer = useRef(null);
const isUnmountingRef = useRef(false);
const manualCloseRef = useRef(false);
const isConnectingRef = useRef(false);





  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    webSocketRef.current = webSocket;
  }, [webSocket]);



  const handleSubmit = async () => {
    const count = await checkMandatory();

    setUnansweredMandatoryCount(count);

    setShowSubmitModal({
      open: true,
      isAuto: false,
      autoReason: null,
    });
  };

  const handleCancelSubmit = () => setShowSubmitModal({ open: false, isAuto: false, autoReason: null });//

  const [examData, setExamData] = useState({
    examId: null,
    ExamEmployeeId: null,
    employeeId: null,
  });




  useEffect(() => {

    if (!location.state?.examData) {

      console.error("❌ No exam data found");
      navigate("/");
      return;
    }

    const apiData = unwrapExamData(location.state.examData);
    const durationMinutes = getExamDurationMinutes(apiData);
    const resolvedExam = {
      ...(apiData.exam || {}),
      ...(durationMinutes ? { "Duration(min)": durationMinutes } : {}),
    };
    let isActive = true;

    // setExamStatus(apiData.status || "Start");
    const examMode =
      apiData.message?.toLowerCase().includes("resume")
        ? "Resume"
        : "Start";

    setExamStatus(examMode);

    console.log("Exam Mode:", examMode);
    setBackNavigationRequired(false);
    console.log("[Exam] Received examData:", apiData);
    console.log("[Exam] duration resolved:", durationMinutes);
    console.log("Exam Mode:", examMode);

    console.log(apiData, "FULL API DATA");

    setExam(resolvedExam);
    setShowInstructions(false);

    setExamData({
      examId: apiData.exam?.Id,
      ExamEmployeeId: apiData.exam_employee_id,
    });

    setExamEmployeeId(apiData.exam_employee_id);
    console.log(
      "RESUME API ORDER",
      apiData.questions.map(q => q.question_id || q.Id)
    );

    const transformedQuestions = (apiData.questions || []).map((q) => {

      // const options = [
      //   { key: "A", text: q.a, image: q.a_path },
      //   { key: "B", text: q.b, image: q.b_path },
      //   { key: "C", text: q.c, image: q.c_path },
      //   { key: "D", text: q.d, image: q.d_path },
      // ].filter((opt) => opt.text || opt.image);
      //   const options = q.options
      // ? q.options.map(opt => ({
      //     key: opt.key,
      //     text: opt.value,
      //     image: opt.image_path
      //   }))
      // : [
      //     { key: "A", text: q.a, image: q.a_path },
      //     { key: "B", text: q.b, image: q.b_path },
      //     { key: "C", text: q.c, image: q.c_path },
      //     { key: "D", text: q.d, image: q.d_path },
      //   ].filter(opt => opt.text || opt.image);
      const options = q.options
        ? q.options.map(opt => ({
          key: opt.key,
          text: opt.text ?? opt.value,
          image: opt.image ?? opt.image_path
        }))
        : [
          { key: "A", text: q.a, image: q.a_path },
          { key: "B", text: q.b, image: q.b_path },
          { key: "C", text: q.c, image: q.c_path },
          { key: "D", text: q.d, image: q.d_path },
        ].filter(opt => opt.text || opt.image);

      return {
        // q: q.question_description || q.question_description,
        // options,
        // questionId: q.Id || q.question_id,
        // question_type_id: q.question_type_id,
        // marks: q.marks,
        // is_blank: q.is_blank,
        // question_image: q.question_image_path,
        // q_topic: q.Topic,
        // q_aitopicperquestion: q.AiTopicForQuestion,
        // q_domain: q.Domain,
        // q_subtopic: q.SubTopic,
        // q_difficulty: q.DifficultyID,
        // q_category: q.CategoryID,
        // q_difficulty_name: q.DifficultyName,
        // q_assessmentgenre: q.ExamGenreId,
        // q_assessmentgenre_name: q.ExamGenreName,
        // is_mandatory: q.IsMandatory

        q: q.question_description,

        options,

        questionId: q.Id ?? q.question_id,

        question_type_id: q.question_type_id,

        marks: q.marks,

        is_blank: q.is_blank,

        question_image:
          q.question_image_path ?? q.question_image,

        q_topic:
          q.Topic ?? q.topic,

        q_aitopicperquestion:
          q.AiTopicForQuestion ?? q.aitopicforquestion,

        q_domain:
          q.Domain ?? q.domain,

        q_subtopic:
          q.SubTopic ?? q.subtopic,

        q_difficulty:
          q.DifficultyID ?? q.difficulty,

        q_category:
          q.CategoryID ?? q.category,

        q_difficulty_name:
          q.DifficultyName ?? q.difficulty,

        q_assessmentgenre:
          q.ExamGenreId ?? q.assessmentgenre,

        q_assessmentgenre_name:
          q.ExamGenreName ?? q.assessmentgenre,

        is_mandatory:
          q.IsMandatory ?? q.is_mandatory,

        options: options,
        question_type_id: q.question_type_id,
        marks: q.marks,
        question_image: q.question_image,
        is_blank: q.is_blank
      };
    });

    console.log(transformedQuestions, "QUESTIONS");
    console.log(apiData.current_question);
    console.log(apiData.questions);
    console.log(transformedQuestions);
    console.log(currentQ);

    setQuestions(transformedQuestions);
    console.log(
      "TRANSFORMED ORDER",
      transformedQuestions.map(q => q.questionId)
    );

    if (apiData.saved_answers?.length > 0) {

      const restoredAnswers = restoreAnswersFromBackend(
        apiData.saved_answers
      );

      setAnswers(restoredAnswers);

      if (apiData.saved_status) {
        setStatus(apiData.saved_status);
      }

    } else {

      setAnswers(Array(transformedQuestions.length).fill(null));

      setStatus(
        Array(transformedQuestions.length).fill("not-visited")
      );
    }

    // setTimeLeft((apiData.duration || 0) * 60);
    setTimeLeft(
      apiData.time_left ??
      (durationMinutes * 60)
    );

    fetchBackNavigationRequired().then((value) => {
      if (!isActive) return;
      setBackNavigationRequired(value);
      console.log("[Exam] backNavigationRequired config:", value);
    });

    return () => {
      isActive = false;
    };

  }, [location.state, navigate]);
  useEffect(() => {
    if (questions.length > 0 && status.length > 0) {
      console.log("Question Navigator Status:", status);
      console.log("Current Question Index:", currentQ);
    }
  }, [questions, status, currentQ]);




  useEffect(() => {
    if (questions.length > 0) {
      // Initialize answers and status if not already set
      setAnswers((prev) => prev.length === questions.length ? prev : Array(questions.length).fill(null));
      setStatus((prev) => prev.length === questions.length ? prev : Array(questions.length).fill("not-visited"));
    }
  }, [questions]);

  const optionKeys = ["A", "B", "C", "D"];

  // Convert backend answer keys to indices for UI
  const restoreAnswersFromBackend = (backendAnswers) => {
    return questions.map((q) => {
      const saved = backendAnswers.find((a) => a.question_id === q.questionId);
      if (!saved) return null;

      if (q.question_type_id === 1) {
        // Single choice
        // return optionKeys.indexOf(saved.answer);
        const idx = optionKeys.indexOf(saved.answer);

        return idx >= 0 ? idx : null;
      } else if (q.question_type_id === 2) {
        // Multiple choice
        // if (!Array.isArray(saved.answer)) return [];
        // return saved.answer.map((a) => optionKeys.indexOf(a)).filter((i) => i !== -1);
        let ansArray = [];
        if (Array.isArray(saved.answer)) {
          ansArray = saved.answer;
        } else if (typeof saved.answer === 'string' && saved.answer.trim()) {
          ansArray = saved.answer.split(',').map(s => s.trim()).filter(Boolean);
        }
        // return ansArray.map((a) => optionKeys.indexOf(a)).filter((i) => i !== -1);
        const restored = ansArray
          .map(a => optionKeys.indexOf(a))
          .filter(i => i >= 0);

        return restored.length ? restored : [];
      } else {
        // Text input
        return saved.answer || "";
      }
    });
  };

  useEffect(() => {
    if (questions.length === 0 || submitted) return;

    if (showInstructions) return;

    const requestFullscreen = () => {
      const elem = document.documentElement;
      if (elem.requestFullscreen) elem.requestFullscreen().catch(() => { });
      else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
      else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
    };

    const triggerViolation = (type, message) => {
      if (isViolationPopupOpen.current) return;

      const now = Date.now();
      if (now - lastViolationAt.current < 750) return;
      lastViolationAt.current = now;
      isViolationPopupOpen.current = true;
      const newCount = violationCount + 1;
      setViolationCount(newCount);
      setLastViolationType(type);
      setViolationMessage(message);
      setViolationAlertOpen(true);
      window.pendingWsSave = true;

      // 🔴 Send violation to backend (WebSocket)
      if (webSocket && webSocket.readyState === WebSocket.OPEN) {
        webSocket.send(JSON.stringify({
          action: "violation",
          payload: {
            type,
            timestamp: new Date().toISOString(),
            exam_employee_id: examData.ExamEmployeeId
          }
        }));
      }

      // Auto-submit if limit reached
      if (newCount >= maxViolations && !showSubmitModal.open) {
        setTimeout(() => {
          setViolationAlertOpen(false);
          setShowSubmitModal({ open: true, isAuto: true, autoReason: "malpractice" });
        }, 500);
      }
    };


    const isExamCompleted = () =>
      sessionStorage.getItem("examCompleted") === "true";


    const handleAssessmentLeave = () => {
      if (isExamCompleted() || isAwayFromAssessment.current) return;

      isAwayFromAssessment.current = true;
      triggerViolation(
        "tab_switch",
        "Switching tabs, windows, or applications is not allowed during the Assessment."
      );
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        handleAssessmentLeave();
      }
    };

    const handleWindowFocus = () => {
      if (document.visibilityState === "visible") {
        isAwayFromAssessment.current = false;
      }
    };

    // 1️⃣ Fullscreen exit
    const handleFullscreenChange = () => {
      const isFS =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement;

      // if (!isFS) {
      //   triggerViolation(
      //     "fullscreen_exit",
      //     "You exited fullscreen. Exam must remain in fullscreen."
      //   );
      //   requestFullscreen();
      if (!isFS) {
        if (isExamCompleted()) return; // 🚫 IGNORE after submit
        if (isAwayFromAssessment.current || isViolationPopupOpen.current) return;

        triggerViolation(
          "fullscreen_exit",
          "You exited fullscreen. Assessment must remain in fullscreen."
        );
        requestFullscreen();


      }
    };

    // 2️⃣ ESC + Refresh
    const handleKeyDown = (e) => {
      if (isExamCompleted()) return;
      if (e.key === "Escape") {
        e.preventDefault();
        triggerViolation(
          "escape_pressed",
          "ESC key is not allowed during Assessment."
        );
        requestFullscreen();
      }

      if (
        (e.ctrlKey && e.key.toLowerCase() === "r") ||
        e.key === "F5"
      ) {
        e.preventDefault();
        triggerViolation(
          "refresh_attempt",
          "Page refresh is not allowed."
        );
      }
    };


    // 3️⃣ Page unload
    const handleBeforeUnload = (e) => {
      if (isExamCompleted()) return;
      e.preventDefault();
      triggerViolation(
        "page_leave_attempt",
        "Leaving Assessment page detected."
      );
      e.returnValue = "";
    };

    // 4️⃣ Browser back button
    const handlePopState = () => {
      if (isExamCompleted()) return;
      window.history.pushState(null, "", window.location.pathname);
      triggerViolation(
        "back_navigation",
        "Back navigation is not allowed."
      );
    };

    window.history.pushState(null, "", window.location.pathname);
    requestFullscreen();

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    document.addEventListener("keydown", handleKeyDown);
    window.addEventListener("blur", handleAssessmentLeave);
    window.addEventListener("focus", handleWindowFocus);
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("blur", handleAssessmentLeave);
      window.removeEventListener("focus", handleWindowFocus);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [questions.length, submitted, violationCount, webSocket, examData, showInstructions]);

  const handleViolationAlertClose = () => {
    setViolationAlertOpen(false);
    isViolationPopupOpen.current = false;
    isAwayFromAssessment.current = false;

    const elem = document.documentElement;
    if (elem.requestFullscreen) elem.requestFullscreen().catch(() => { });
  };

  const ViolationAlertDialog = () => (
    <div style={{
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(0,0,0,0.92)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    }}>
      <div style={{
        background: "#fff",
        padding: "40px",
        borderRadius: "16px",
        maxWidth: "600px",
        textAlign: "center"
      }}>
        <h2 style={{ color: "#d32f2f" }}>⚠ Proctoring Violation</h2>
        <p>{violationMessage}</p>
        <p><b>{violationCount} / {maxViolations}</b></p>

        <button onClick={handleViolationAlertClose}>
          Continue Assessment
        </button>
      </div>
    </div>
  );
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("examCompleted");
    };
  }, []);

  /** Returns true if the answer for a question is *empty* */
  const isAnswerEmpty = (question, answer) => {
    if (question.question_type_id === 1) {
      // single-choice – null/undefined = empty
      return answer == null;
    }
    if (question.question_type_id === 2) {
      // multi-choice – empty array = empty
      return !Array.isArray(answer) || answer.length === 0;
    }
    if (question.question_type_id === 3) {
      // fill-in-the-blank – empty string = empty
      return typeof answer !== "string" || answer.trim() === "";
    }
    return true;
  };
  const sendStartExam = (wsInstance) => {
    if (!wsInstance || wsInstance.readyState !== WebSocket.OPEN || questions.length === 0) return;

    console.log("========== sendStartExam CALLED ==========");
    console.trace();
    console.log("examStatus =", examStatus);


    // const questionDescriptions = {};
    // questions.forEach((q) => {
    //   questionDescriptions[q.questionId] = {
    //     description: q.q,
    //     topic: q.q_topic,
    //     aitopicforquestion: q.q_aitopicperquestion,
    //     domain: q.q_domain,
    //     subtopic: q.q_subtopic,
    //     difficulty: q.q_difficulty,
    //     category: q.q_category,
    //     assessmentgenre: q.q_assessmentgenre,
    //     difficulty_name: q.q_difficulty_name,
    //     assessmentgenre_name: q.q_assessmentgenre_name,
    //     is_mandatory: q.is_mandatory,
    //       options: q.options,
    // question_type_id: q.question_type_id,
    // marks: q.marks,
    // question_image: q.question_image,
    // is_blank: q.is_blank
    //   };
    // });

    const questionDescriptions = questions.map(q => ({
      question_id: q.questionId,
      description: q.q,
      topic: q.q_topic,
      aitopicforquestion: q.q_aitopicperquestion,
      domain: q.q_domain,
      subtopic: q.q_subtopic,
      difficulty: q.q_difficulty,
      category: q.q_category,
      assessmentgenre: q.q_assessmentgenre,
      difficulty_name: q.q_difficulty_name,
      assessmentgenre_name: q.q_assessmentgenre_name,
      is_mandatory: q.is_mandatory,
      options: q.options,
      question_type_id: q.question_type_id,
      marks: q.marks,
      question_image: q.question_image,
      is_blank: q.is_blank
    }));


    const passPercent = exam?.PassPercent;

    const payload = {
      exam_id: examData.examId,
      exam_employee_id: examData.ExamEmployeeId,
      question_descriptions: questionDescriptions,
      pass_percent: passPercent,
      duration: exam["Duration(min)"],
      review_with_answers: exam.ReviewWithAnswers
    };

    console.log("📦 Start Exam Payload:", payload);
    window.pendingWsSave = false;

    wsInstance.send(
      JSON.stringify({
        action: "start_exam",
        payload,
      })
    );
  };

  const reconnectWebSocket = () => {

    setTimeout(() => {

      console.log("Trying to reconnect...");

      // connectWebSocket();

    }, 5000);

  };

  //   useEffect(() => {
  //     if (!exam || !examData.ExamEmployeeId || !questions.length) return;

  //     connectWebSocket();

  //     return () => {
  //         if (reconnectTimer.current) {
  //             clearTimeout(reconnectTimer.current);
  //         }

  //         if (webSocket) {
  //             webSocket.close();
  //         }
  //     };
  // }, [exam, examData, questions, examStatus]);

  // useEffect(() => {
  //   if (!exam || !examData.ExamEmployeeId || !questions.length) return;

  //   connectWebSocket(examStatus);

  //   return () => {
  //     if (reconnectTimer.current) {
  //       clearTimeout(reconnectTimer.current);
  //     }

  //     if (webSocket) {
  //       webSocket.close();
  //     }
  //   };
  // }, [exam, examData, questions, examStatus]);

  useEffect(() => {

    if (

        !exam ||

        !examData?.ExamEmployeeId ||

        !questions.length

    ) {

        return;

    }
 
    isUnmountingRef.current = false;
 
    console.log("🚀 Initial WebSocket connection");
 
    // This is the ONLY initial Start connection

    connectWebSocket(examStatus === "Start" ? "Start" : "Resume");
 
    return () => {

        console.log("🧹 WebSocket cleanup");
 
        isUnmountingRef.current = true;

        manualCloseRef.current = true;
 
        if (reconnectTimer.current) {

            clearTimeout(reconnectTimer.current);

            reconnectTimer.current = null;

        }
 
        if (wsRef.current) {

            wsRef.current.close();

            wsRef.current = null;

        }

    };
 
}, [

    exam?.Id,

    examData?.ExamEmployeeId

]);
 
  //   const connectWebSocket = (mode) => {
  //     if (!exam || !examData.ExamEmployeeId || !questions.length) return;

  //     const ws = new WebSocket(
  //       `ws://localhost:8000/ws/exam/${examData.examId}/${examData.ExamEmployeeId}/`
  //     );

  //     //     const ws = new WebSocket(
  //     //   `${wsProtocol}://${wsHost}/ws/exam/${examData.examId}/${examData.ExamEmployeeId}/`
  //     // );

  //     console.log("Connecting WebSocket...");

  //     ws.onopen = () => {
  //       console.log("✅ WebSocket Connected");

  //       setWebSocket(ws);

  //       setConnectionLost(false);
  //       setMongoSyncFailed(false);

  //       setRetrying(false);
  //       setConnectionLost(false);

  //       // Sync pending answers
  //       syncPendingAnswers(ws);
  //       console.log("Exam Status in ws.onopen =", examStatus);
  // console.log("Mode =", mode);

  // if (mode === "Start") {
  //     sendStartExam(ws);
  // } else {
  //     console.log("Resume detected - skipping start_exam");
  // }

  //       // Stop retry timer
  //       if (reconnectTimer.current) {
  //         clearTimeout(reconnectTimer.current);
  //         reconnectTimer.current = null;
  //       }
  //     };

  //     ws.onmessage = (event) => {
  //       const data = JSON.parse(event.data);
  //       if (data.action === "force_submit") {
  //         setShowSubmitModal({ open: true, isAuto: true, autoReason: data.reason || "malpractice" });
  //         return;
  //       }


  //       if (data.action === "init") {
  //         const payload = data.payload || {};
  //         console.log(payload, "DDDDDDDDD")

  //         if (payload.violations_count !== undefined) {
  //           setViolationCount(payload.violations_count);
  //         }

  //         // Restore answers

  //         if (Array.isArray(payload.answers) && payload.answers.length) {
  //           const restoredAnswers = restoreAnswersFromBackend(payload.answers);
  //           setAnswers(restoredAnswers);
  //         } else {
  //           setAnswers(Array(questions.length).fill(null));
  //         }

  //         const restoredSync = {};

  //         payload.answers.forEach(answer => {

  //           // restoredSync[answer.question_id] = "mongo";
  //             restoredSync[answer.question_id] =
  //         answer.sync || "mongo";

  //         });

  //         setSyncStatus(restoredSync);

  //         // Restore status
  //         if (Array.isArray(payload.status) && payload.status.length) {
  //           setStatus(payload.status);
  //         } else {
  //           setStatus(Array(questions.length).fill("not-visited"));
  //         }

  //         // Restore timer
  //         if (payload.time_left !== undefined) {
  //           setTimeLeft(payload.time_left);
  //           console.log("hw")
  //         } else if (exam?.["Duration(min)"]) {
  //           setTimeLeft(exam["Duration(min)"] * 60);
  //         }

  //         if (payload.current_question !== undefined) {
  //           setCurrentQ(payload.current_question);

  //         }

  //         console.log(exam["Duration(min)"], "^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");

  //         console.log("🔁 Restored exam state from backend:", payload);
  //       }
  //       // if (data.action === "save_success") {
  //       //    window.pendingWsSave = false;
  //       //   setMongoSyncFailed(false);

  //       // }
  //       if (data.action === "save_success") {

  //         clearTimeout(
  //           ackTimers.current[data.question_id]
  //         );

  //         delete ackTimers.current[data.question_id];

  //         removePendingAnswer(data.question_id);
  //         window.pendingWsSave = getPendingCount() > 0;
  //           setMongoSyncFailed(false);

  //         setSyncStatus(prev => ({

  //           ...prev,

  //           [data.question_id]: "mongo"

  //         }));
  //         console.log("Pending:", getPendingAnswers());
  // console.log("Sync:", syncStatus);
  // console.log(
  //     "ACK received",
  //     data.question_id,
  //     data.sync
  // );

  // console.log(
  //     "Before remove",
  //     getPendingAnswers()
  // );



  // console.log(
  //     "After remove",
  //     getPendingAnswers()
  // );

  //       }



  //       if (data.action === "save_failed") {
  //         setMongoSyncFailed(true);

  //         console.error(data.message);
  //         window.pendingWsSave = false;

  //         alert(data.message);
  //       }
  //       if (data.action === "update") {
  //         const { question_id, answer: rawAnswer, status: qStatus, time_left } = data.payload;
  //         const qIndex = questions.findIndex((q) => q.questionId === question_id);
  //         if (qIndex >= 0) {
  //           const question = questions[qIndex];

  //           // Convert raw backend answer to UI indices (same logic as restore)
  //           let uiAnswer;
  //           if (question.question_type_id === 1) {
  //             uiAnswer = optionKeys.indexOf(rawAnswer);
  //           } else if (question.question_type_id === 2) {
  //             let ansArray = [];
  //             if (Array.isArray(rawAnswer)) {
  //               ansArray = rawAnswer;
  //             } else if (typeof rawAnswer === 'string' && rawAnswer.trim()) {
  //               ansArray = rawAnswer.split(',').map(s => s.trim()).filter(Boolean);
  //             }
  //             uiAnswer = ansArray.map((a) => optionKeys.indexOf(a)).filter((i) => i !== -1);
  //           } else {
  //             uiAnswer = rawAnswer || "";
  //           }

  //           setAnswers((prev) => {
  //             const newArr = [...prev];
  //             newArr[qIndex] = uiAnswer;  // Now ALWAYS indices!
  //             return newArr;
  //           });
  //           setStatus((prev) => {
  //             const newArr = [...prev];
  //             newArr[qIndex] = qStatus;
  //             return newArr;
  //           });
  //         }
  //         if (time_left !== undefined) setTimeLeft(time_left);
  //       }

  //     };


  //     ws.onclose = () => {
  //       console.log("❌ WebSocket Closed");

  //       setConnectionLost(true);

  //       // Auto reconnect after 5 seconds
  //       reconnectTimer.current = setTimeout(() => {
  //         console.log("Trying automatic reconnect...");
  //         // connectWebSocket();
  //         connectWebSocket(examStatus);
  //       }, 5000);
  //     };



  //     ws.onerror = (error) => {

  //       console.error("WebSocket Error", error);

  //       setConnectionLost(true);

  //       if (ws.readyState !== WebSocket.CLOSED) {
  //         ws.close();
  //       }

  //     };
  //   };

  const connectWebSocket = (mode) => {

    // Don't create another connection if one is already opening/open

    if (

      wsRef.current &&

      (

        wsRef.current.readyState === WebSocket.OPEN ||

        wsRef.current.readyState === WebSocket.CONNECTING

      )

    ) {

      console.log(

        "⚠️ WebSocket already OPEN/CONNECTING - skipping new connection"

      );

      return;

    }

    if (isConnectingRef.current) {

      console.log("⚠️ WebSocket connection already in progress");

      return;

    }

    if (!exam || !examData?.ExamEmployeeId || !questions.length) {

      console.log("⚠️ Cannot connect WebSocket - missing exam data");

      return;

    }

    // Clear old reconnect timer before creating a new connection

    if (reconnectTimer.current) {

      clearTimeout(reconnectTimer.current);

      reconnectTimer.current = null;

    }

    isConnectingRef.current = true;

    manualCloseRef.current = false;

    const connectionId = `${Date.now()}-${Math.random()

      .toString(36)

      .substring(2, 7)}`;

    console.log(

      `[WS ${connectionId}] Creating connection | mode=${mode}`

    );

      const wsProtocol = window.location.protocol === "https:" ? "wss" : "ws";
    const wsHost = window.location.host;

    // const ws = new WebSocket(

    //   `ws://localhost:8000/ws/exam/${examData.examId}/${examData.ExamEmployeeId}/`

    // );

              const ws = new WebSocket(
        `${wsProtocol}://${wsHost}/ws/exam/${examData.examId}/${examData.ExamEmployeeId}/`
      );

    wsRef.current = ws;

    ws.onopen = () => {

      console.log(`[WS ${connectionId}] ✅ OPEN`);

      isConnectingRef.current = false;

      // Important: ignore this socket if another socket replaced it

      if (wsRef.current !== ws) {

        console.log(

          `[WS ${connectionId}] Old socket opened - closing`

        );

        ws.close();

        return;

      }

      setWebSocket(ws);

      setConnectionLost(false);

      setMongoSyncFailed(false);

      setRetrying(false);

      // Sync only pending answers

      // syncPendingAnswers(ws);

      console.log(

        `[WS ${connectionId}] Connected successfully | mode=${mode}`

      );
      ws.onmessage = (event) => {

    // Ignore messages from old WebSocket
    if (wsRef.current !== ws) {
        console.log(
            `[WS ${connectionId}] Ignoring old socket message`
        );
        return;
    }

    const data = JSON.parse(event.data);

    console.log(
        `[WS ${connectionId}] MESSAGE RECEIVED:`,
        data
    );


    // ==========================================
    // 1. INIT - RESTORE EXAM FROM MONGO
    // ==========================================
    if (data.action === "init") {

        const payload = data.payload || {};

        console.log("========== RESTORE INIT ==========");
        console.log("INIT PAYLOAD:", payload);

        const backendAnswers = Array.isArray(payload.answers)
            ? payload.answers
            : [];


        // Restore answers
        const restoredAnswers =
            restoreAnswersFromBackend(backendAnswers);

        console.log(
            "RESTORED ANSWERS:",
            restoredAnswers
        );

        setAnswers(restoredAnswers);


        // Restore status from Mongo answers
        const restoredStatus = questions.map((question) => {

            const mongoAnswer = backendAnswers.find(
                (answer) =>
                    Number(answer.question_id) ===
                    Number(question.questionId)
            );

            return mongoAnswer?.status || "not-visited";
        });

        console.log(
            "RESTORED STATUS:",
            restoredStatus
        );

        setStatus(restoredStatus);


        // Restore sync status
        const restoredSync = {};

        backendAnswers.forEach((answer) => {

            restoredSync[String(answer.question_id)] =
                answer.sync === "mongo"
                    ? "mongo"
                    : "local";
        });

        console.log(
            "RESTORED SYNC:",
            restoredSync
        );

        setSyncStatus(restoredSync);


        // Restore timer
        if (payload.time_left !== undefined) {
            setTimeLeft(payload.time_left);
        }


        // Restore current question
        if (payload.current_question !== undefined) {
            setCurrentQ(Number(payload.current_question));
        }


        // Restore violations
        if (payload.violations_count !== undefined) {
            setViolationCount(payload.violations_count);
        }

        console.log("========== RESTORE COMPLETED ==========");
        const pendingAnswers = getPendingAnswers(examEmployeeId);

if (
    Object.keys(pendingAnswers).length > 0 &&
    ws.readyState === WebSocket.OPEN
) {
    console.log(
        "[INIT] Mongo restored. Syncing pending local answers."
    );

    syncPendingAnswers(ws);
}

        return;
    }


    // ==========================================
    // 2. SAVE SUCCESS
    // ==========================================
    if (data.action === "save_success") {

        clearTimeout(
            ackTimers.current[data.question_id]
        );

        delete ackTimers.current[data.question_id];

        removePendingAnswer(examEmployeeId,data.question_id);

        window.pendingWsSave =
            getPendingCount(examEmployeeId) > 0;

        setMongoSyncFailed(false);

        setSyncStatus(prev => ({
            ...prev,
            [String(data.question_id)]: "mongo"
        }));

        console.log(
            "Mongo ACK received:",
            data.question_id
        );

        return;
    }


    // ==========================================
    // 3. SAVE FAILED
    // ==========================================
    if (data.action === "save_failed") {

        setMongoSyncFailed(true);

        console.error(
            "Mongo save failed:",
            data.message
        );

        return;
    }


    // ==========================================
    // 4. UPDATE
    // Keep this if backend sends update messages
    // ==========================================
    if (data.action === "update") {

        const {
            question_id,
            answer: rawAnswer,
            status: qStatus,
            time_left
        } = data.payload || {};

        const qIndex = questions.findIndex(
            q =>
                Number(q.questionId) ===
                Number(question_id)
        );

        if (qIndex === -1) {
            console.error(
                "UPDATE: Question not found:",
                question_id
            );
            return;
        }

        setStatus(prev => {
            const updated = [...prev];
            updated[qIndex] =
                qStatus || "not-visited";
            return updated;
        });

        if (time_left !== undefined) {
            setTimeLeft(time_left);
        }

        return;
    }


    // ==========================================
    // 5. FORCE SUBMIT
    // ==========================================
    if (data.action === "force_submit") {

        setShowSubmitModal({
            open: true,
            isAuto: true,
            autoReason:
                data.reason || "malpractice"
        });

        return;
    }

};

      /*

       * Keep your existing first-time initialization logic here.

       *

       * IMPORTANT:

       * Reconnection must NOT initialize the exam again.

       */

      if (mode === "Start") {

        console.log(

          `[WS ${connectionId}] start_exam allowed only for initial connection`

        );

        sendStartExam(ws);

      } else {

        console.log(

          `[WS ${connectionId}] Reconnect/Resume - skipping start_exam`

        );

      }

    };

    ws.onmessage = (event) => {

      // Ignore messages from an old socket

      if (wsRef.current !== ws) {

        console.log(

          `[WS ${connectionId}] Ignoring message from old socket`

        );

        return;

      }

      const data = JSON.parse(event.data);

      // ===== KEEP YOUR EXISTING onmessage CODE HERE =====

      if (data.action === "save_success") {

        clearTimeout(ackTimers.current[data.question_id]);

        delete ackTimers.current[data.question_id];

        removePendingAnswer(examEmployeeId,data.question_id);

        window.pendingWsSave = getPendingCount(examEmployeeId) > 0;

        setMongoSyncFailed(false);

        setSyncStatus(prev => ({

          ...prev,

          [data.question_id]: "mongo"

        }));

        return;

      }

      if (data.action === "save_failed") {

        setMongoSyncFailed(true);

        console.error(data.message);

        return;

      }

      // Add the rest of your existing handlers:

      // init

      // update

      // force_submit

      // etc.

    };

    ws.onerror = (error) => {

      console.error(`[WS ${connectionId}] ❌ ERROR`, error);

    };

    ws.onclose = () => {

      console.log(`[WS ${connectionId}] CLOSED`);

      isConnectingRef.current = false;

      // VERY IMPORTANT:

      // Ignore old sockets.

      if (wsRef.current !== ws) {

        console.log(

          `[WS ${connectionId}] Old socket closed - no reconnect`

        );

        return;

      }

      // Do not reconnect if component is being destroyed

      if (isUnmountingRef.current) {

        console.log(

          `[WS ${connectionId}] Component unmounting - no reconnect`

        );

        return;

      }

      // Do not reconnect when we intentionally closed it

      if (manualCloseRef.current) {

        console.log(

          `[WS ${connectionId}] Intentional close - no reconnect`

        );

        return;

      }

      wsRef.current = null;

      setConnectionLost(true);

      // Prevent multiple reconnect timers

      if (reconnectTimer.current) {

        clearTimeout(reconnectTimer.current);

      }

      console.log(

        `[WS ${connectionId}] 🔄 Scheduling reconnect in 5 seconds`

      );

      reconnectTimer.current = setTimeout(() => {

        reconnectTimer.current = null;

        console.log(

          `[WS ${connectionId}] 🔄 Reconnecting...`

        );

        // IMPORTANT:

        // Reconnect mode, not Start mode

        connectWebSocket("Reconnect");

      }, 5000);

    };

  };

  useEffect(() => {

    const handleOffline = () => {
      console.log("Internet disconnected");

      setConnectionLost(true);
    };

    // const handleOnline = () => {
    //   console.log("Internet connected");

    //   retryConnection();
    // };
    const handleOnline = () => {

      console.log("🌐 Internet connected");

      if (

        wsRef.current &&

        wsRef.current.readyState === WebSocket.OPEN

      ) {

        console.log(

          "WebSocket already connected - no retry needed"

        );

        return;

      }

      retryConnection();

    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };

  }, []);



  // useEffect(() => {
  //   if (!exam || !examData.ExamEmployeeId || !questions.length) return;

  //   connectWebSocket();

  //   return () => {
  //     if (reconnectTimer.current) {
  //       clearTimeout(reconnectTimer.current);
  //     }

  //     if (webSocket) {
  //       webSocket.close();
  //     }
  //   };
  // }, [exam, examData, questions]);


  // const retryConnection = () => {

  //   if (retrying) return;

  //   setRetrying(true);

  //   if (webSocket) {
  //     webSocket.close();
  //   }

  //   // connectWebSocket();
  //   connectWebSocket(examStatus);

  //   setTimeout(() => {
  //     setRetrying(false);
  //   }, 3000);

  // };
  const retryConnection = () => {

    if (retrying) return;

    console.log("🔄 Manual retry requested");

    setRetrying(true);

    // Cancel automatic reconnect

    if (reconnectTimer.current) {

      clearTimeout(reconnectTimer.current);

      reconnectTimer.current = null;

    }

    // If a connection is already active, don't create another one

    if (

      wsRef.current &&

      (

        wsRef.current.readyState === WebSocket.OPEN ||

        wsRef.current.readyState === WebSocket.CONNECTING

      )

    ) {

      console.log(

        "WebSocket already active - retry not required"

      );

      setRetrying(false);

      setConnectionLost(false);

      return;

    }

    // IMPORTANT: Reconnect is NOT Start

    connectWebSocket("Reconnect");

    setTimeout(() => {

      setRetrying(false);

    }, 3000);

  };

  useEffect(() => {
    if (questions.length === 0) return;

    setStatus((prevStatus) => {
      const targetLength = questions.length;

      // Case 1: status is empty or wrong length → fill with "not-visited"
      if (!prevStatus || prevStatus.length === 0 || prevStatus.length !== targetLength) {
        console.log("Status missing or mismatched → defaulting to not-visited");
        return Array(targetLength).fill("not-visited");
      }

      // Case 2: status shorter than questions → pad with not-visited
      if (prevStatus.length < targetLength) {
        return [
          ...prevStatus,
          ...Array(targetLength - prevStatus.length).fill("not-visited")
        ];
      }

      // Case 3: status longer (shouldn't happen) → trim
      if (prevStatus.length > targetLength) {
        return prevStatus.slice(0, targetLength);
      }

      // Case 4: perfect match → return as is
      return prevStatus;
    });
  }, [questions]);


  useEffect(() => {

    if (
      submitted ||
      showInstructions ||
      questions.length === 0 ||
      sessionStorage.getItem("examCompleted") === "true"
    ) {
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        const newTime = Math.max(prev - 1, 0);
        const socket = webSocketRef.current;

        if (socket && socket.readyState === WebSocket.OPEN && newTime > 0) {
          socket.send(
            JSON.stringify({
              action: "time_update",
              payload: { time_left: newTime },
            })
          );
        }

        if (newTime <= 0 && !autoSubmitTriggered.current) {
          autoSubmitTriggered.current = true;
          timeUpPersisted.current = true;

          if (socket && socket.readyState === WebSocket.OPEN) {
            socket.send(
              JSON.stringify({
                action: "time_update",
                payload: { time_left: 0 },
              })
            );
          }

          if (
            sessionStorage.getItem("examCompleted") !== "true"
          ) {
            setShowSubmitModal({
              open: true,
              isAuto: true,
              autoReason: "timeout"
            });
          }
        }

        return newTime;
      });

      setUsedTime((prev) => (autoSubmitTriggered.current ? prev : prev + 1));
    }, 1000);

    return () => clearInterval(timer);

  }, [submitted, showInstructions, questions.length]);

  useEffect(() => {
    if (
      timeLeft !== 0 ||
      submitted ||
      showInstructions ||
      questions.length === 0 ||
      sessionStorage.getItem("examCompleted") === "true" ||
      autoSubmitTriggered.current
    ) {
      return;
    }

    autoSubmitTriggered.current = true;

    const socket = webSocketRef.current;
    if (!timeUpPersisted.current && socket && socket.readyState === WebSocket.OPEN) {
      timeUpPersisted.current = true;
      socket.send(
        JSON.stringify({
          action: "time_update",
          payload: { time_left: 0 },
        })
      );
    }

    setShowSubmitModal({
      open: true,
      isAuto: true,
      autoReason: "timeout"
    });
  }, [timeLeft, submitted, showInstructions, questions.length]);






  const sendWsUpdate = (qIndex, answer, qStatus) => {
    // if (!webSocket || webSocket.readyState !== WebSocket.OPEN) return;

    const question = questions[qIndex];
    window.pendingWsSave = true;

    console.log(
      "sendWsUpdate",
      qIndex,
      questions[qIndex]
    );

    savePendingAnswer({
      question_id: question.questionId,
      answer,
      examEmployeeId,
      status: qStatus,
      sync: "local",
      time_left: timeLeft
    });
    setSyncStatus(prev => ({

      ...prev,

      [question.questionId]: "local"

    }));

    if (!webSocket || webSocket.readyState !== WebSocket.OPEN) {

      return;
    }

    ackTimers.current[question.questionId] = setTimeout(() => {

      console.warn(
        `No ACK received for Question ${question.questionId}`
      );

      // setConnectionLost(true);
      setMongoSyncFailed(true);

    }, 5000);

    webSocket.send(
      JSON.stringify({
        action: "answer",
        payload: {
          question_id: question.questionId,
          answer,
          status: qStatus,
          sync: "mongo",
          time_left: timeLeft,
        },
      })
    );
  };


  const syncPendingAnswers = (socket) => {

    const pending = getPendingAnswers(examEmployeeId);

    Object.values(pending).forEach(answer => {

      socket.send(JSON.stringify({

        action: "answer",

        payload: answer

      }));

    });

  }

  const sendCurrentQuestion = (questionIndex) => {
    if (!webSocket || webSocket.readyState !== WebSocket.OPEN) return;



    webSocket.send(
      JSON.stringify({
        action: "current_question",
        payload: {
          current_question: questionIndex,
        },
      })
    );
  };

  const updateQuestionStatus = (
    qIndex,
    newStatus,
    answerToSend = null
  ) => {

    setStatus(prev => {

      // If nothing changed, don't update
      if (prev[qIndex] === newStatus) {
        return prev;
      }

      const updated = [...prev];
      updated[qIndex] = newStatus;

      return updated;
    });

    sendWsUpdate(
      qIndex,
      answerToSend,
      newStatus
    );
  };

  //  NEW selectOption  (drop-in replacement)
  const selectOption = (qIndex, optIndex) => {
    const question = questions[qIndex];
    const newAnswers = [...answers];

    /* ---------- 1. Build UI answer (index / array / string) ---------- */
    if (question.question_type_id === 1) {
      // SINGLE CHOICE – click the same option again → deselect
      newAnswers[qIndex] = answers[qIndex] === optIndex ? null : optIndex;
    } else if (question.question_type_id === 2) {
      // MULTI CHOICE – toggle the clicked index
      const prev = Array.isArray(answers[qIndex]) ? answers[qIndex] : [];
      newAnswers[qIndex] = prev.includes(optIndex)
        ? prev.filter(i => i !== optIndex)          // remove
        : [...prev, optIndex];                       // add
    } else {
      // TEXT INPUT (type 3) – optIndex is the raw string from <input>
      newAnswers[qIndex] = optIndex;
    }

    setAnswers(newAnswers);

    /* ---------- 2. Decide status based on emptiness ---------- */
    const empty = (() => {
      if (question.question_type_id === 1) return newAnswers[qIndex] == null;
      if (question.question_type_id === 2) return !Array.isArray(newAnswers[qIndex]) || newAnswers[qIndex].length === 0;
      if (question.question_type_id === 3) return typeof newAnswers[qIndex] !== "string" || newAnswers[qIndex].trim() === "";
      return true;
    })();

    // const newStatus = [...status];
    // // newStatus[qIndex] = empty ? "not-answered" : "answered";
    // if (empty) {
    //   newStatus[qIndex] = "not-answered";
    // } else {
    //   newStatus[qIndex] =
    //     status[qIndex] === "marked" || status[qIndex] === "answered-marked"
    //       ? "answered-marked"
    //       : "answered";
    // }
    // setStatus(newStatus);

    /* ---------- 3. Build payload for WebSocket (same format you had) ---------- */
    let answerToSend;
    if (question.question_type_id === 1) {
      answerToSend = newAnswers[qIndex] !== null ? optionKeys[newAnswers[qIndex]] : null;
    } else if (question.question_type_id === 2) {
      answerToSend = newAnswers[qIndex].map(i => optionKeys[i]);   // e.g. ["A","C"]
    } else {
      answerToSend = newAnswers[qIndex];   // string (or "")
    }

    // /* ---------- 4. Send update ---------- */
    // sendWsUpdate(qIndex, answerToSend, newStatus[qIndex]);
    const nextStatus =
      empty
        ? "not-answered"
        : (
          status[qIndex] === "marked" ||
          status[qIndex] === "answered-marked"
        )
          ? "answered-marked"
          : "answered";

    updateQuestionStatus(
      qIndex,
      nextStatus,
      answerToSend
    );
  };


  const clearResponse = (qIndex) => {
    const newAnswers = [...answers];
    newAnswers[qIndex] = null;
    setAnswers(newAnswers);

    const newStatus = [...status];
    newStatus[qIndex] = "not-answered";
    updateQuestionStatus(
      qIndex,
      "not-answered",
      null
    );
    // setStatus(newStatus);

    // const question = questions[qIndex];

    // // Reset sync status immediately
    // setSyncStatus(prev => ({
    //   ...prev,
    //   [question.questionId]: "local"
    // }));

    // sendWsUpdate(qIndex, null, newStatus[qIndex]);
  };

  const markReview = (qIndex) => {
    const newStatus = [...status];
    const question = questions[qIndex];
    const currentAnswer = answers[qIndex];

    const hasAnswer =
      question.question_type_id === 1
        ? currentAnswer !== null && currentAnswer >= 0
        : question.question_type_id === 2
          ? Array.isArray(currentAnswer) && currentAnswer.length > 0
          : typeof currentAnswer === "string" &&
          currentAnswer.trim() !== "";

    const isAlreadyMarked =
      newStatus[qIndex] === "marked" ||
      newStatus[qIndex] === "answered-marked";

    // Toggle Mark for Review
    // if (isAlreadyMarked) {
    //   newStatus[qIndex] = hasAnswer ? "answered" : "not-answered";
    // } else {
    //   newStatus[qIndex] = hasAnswer ? "answered-marked" : "marked";
    // }
    if (!hasAnswer) {
      newStatus[qIndex] = isAlreadyMarked
        ? "not-answered"
        : "marked";
    } else {
      newStatus[qIndex] = isAlreadyMarked
        ? "answered"
        : "answered-marked";
    }

    // setStatus(newStatus);

    let answerToSend;

    if (question.question_type_id === 1) {
      answerToSend =
        currentAnswer !== null ? optionKeys[currentAnswer] : null;
    } else if (question.question_type_id === 2) {
      answerToSend = Array.isArray(currentAnswer)
        ? currentAnswer.map(i => optionKeys[i])
        : [];
    } else {
      answerToSend = currentAnswer;
    }

    // sendWsUpdate(qIndex, answerToSend, newStatus[qIndex]);
    updateQuestionStatus(
      qIndex,
      newStatus[qIndex],
      answerToSend
    );

    // Go to next question only when marking
    // if (!isAlreadyMarked) {
    //   nextQ();
    // }
  };
  // const nextQ = () => {
  //   setStatus((prevStatus) => {
  //     const updated = [...prevStatus];
  //     if (updated[currentQ] === "not-visited") {
  //       updated[currentQ] = "not-answered";
  //     }
  //     return updated;
  //   });
  //   // if (currentQ < questions.length - 1) setCurrentQ(currentQ + 1);
  //   if (currentQ < questions.length - 1) {
  //     const nextIndex = currentQ + 1;
  //     setCurrentQ(nextIndex);
  //     sendCurrentQuestion(nextIndex);
  //   }
  // };

  const nextQ = () => {

    // if (
    //     status[currentQ] === "not-visited"
    // ) {

    //     updateQuestionStatus(
    //         currentQ,
    //         "not-answered",
    //         null
    //     );
    // }
    const question = questions[currentQ];
    const currentAnswer = answers[currentQ];

    let hasAnswer = false;
    let answerToSend = null;

    if (question.question_type_id === 1) {
      hasAnswer = currentAnswer !== null &&
        currentAnswer >= 0;
      answerToSend = hasAnswer
        ? optionKeys[currentAnswer]
        : null;
    }
    else if (question.question_type_id === 2) {
      hasAnswer =
        Array.isArray(currentAnswer) &&
        currentAnswer.length > 0;

      answerToSend = hasAnswer
        ? currentAnswer.map(i => optionKeys[i])
        : [];
    }
    else {
      hasAnswer =
        typeof currentAnswer === "string" &&
        currentAnswer.trim() !== "";

      answerToSend = currentAnswer;
    }

    let newStatus = status[currentQ];

    switch (status[currentQ]) {

      case "not-visited":
        newStatus = hasAnswer
          ? "answered"
          : "not-answered";
        break;

      case "marked":
        newStatus = hasAnswer
          ? "answered-marked"
          : "marked";
        break;

      case "answered-marked":
        newStatus = hasAnswer
          ? "answered-marked"
          : "marked";
        break;

      case "answered":
        newStatus = hasAnswer
          ? "answered"
          : "not-answered";
        break;

      case "not-answered":
        newStatus = hasAnswer
          ? "answered"
          : "not-answered";
        break;

      default:
        break;
    }

    updateQuestionStatus(
      currentQ,
      newStatus,
      answerToSend
    );

    if (
      currentQ < questions.length - 1
    ) {

      const nextIndex = currentQ + 1;

      setCurrentQ(nextIndex);

      sendCurrentQuestion(nextIndex);
    }

  };


  const prevQ = () => {

    if (!backNavigationRequired)
      return;

    // if (
    //     status[currentQ] === "not-visited"
    // ) {

    //     updateQuestionStatus(
    //         currentQ,
    //         "not-answered",
    //         null
    //     );
    // }
    const question = questions[currentQ];
    const currentAnswer = answers[currentQ];

    let hasAnswer = false;
    let answerToSend = null;

    if (question.question_type_id === 1) {
      hasAnswer = currentAnswer !== null &&
        currentAnswer >= 0;
      answerToSend = hasAnswer
        ? optionKeys[currentAnswer]
        : null;
    }
    else if (question.question_type_id === 2) {
      hasAnswer =
        Array.isArray(currentAnswer) &&
        currentAnswer.length > 0;

      answerToSend = hasAnswer
        ? currentAnswer.map(i => optionKeys[i])
        : [];
    }
    else {
      hasAnswer =
        typeof currentAnswer === "string" &&
        currentAnswer.trim() !== "";

      answerToSend = currentAnswer;
    }

    let newStatus = status[currentQ];

    switch (status[currentQ]) {

      case "not-visited":
        newStatus = hasAnswer
          ? "answered"
          : "not-answered";
        break;

      case "marked":
        newStatus = hasAnswer
          ? "answered-marked"
          : "marked";
        break;

      case "answered-marked":
        newStatus = hasAnswer
          ? "answered-marked"
          : "marked";
        break;

      case "answered":
        newStatus = hasAnswer
          ? "answered"
          : "not-answered";
        break;

      case "not-answered":
        newStatus = hasAnswer
          ? "answered"
          : "not-answered";
        break;

      default:
        break;
    }

    updateQuestionStatus(
      currentQ,
      newStatus,
      answerToSend
    );
    if (currentQ > 0) {

      const prevIndex = currentQ - 1;

      setCurrentQ(prevIndex);

      sendCurrentQuestion(prevIndex);
    }

  };


  const loadQuestion = (index) => {

    if (
      !backNavigationRequired &&
      index < currentQ
    ) {
      return;
    }

    // if (
    //     status[currentQ] === "not-visited"
    // ) {

    //     updateQuestionStatus(
    //         currentQ,
    //         "not-answered",
    //         null
    //     );
    // }
    const question = questions[currentQ];
    const currentAnswer = answers[currentQ];

    let hasAnswer = false;
    let answerToSend = null;

    if (question.question_type_id === 1) {
      hasAnswer = currentAnswer !== null;
      answerToSend = hasAnswer
        ? optionKeys[currentAnswer]
        : null;
    }
    else if (question.question_type_id === 2) {
      hasAnswer =
        Array.isArray(currentAnswer) &&
        currentAnswer.length > 0;

      answerToSend = hasAnswer
        ? currentAnswer.map(i => optionKeys[i])
        : [];
    }
    else {
      hasAnswer =
        typeof currentAnswer === "string" &&
        currentAnswer.trim() !== "";

      answerToSend = currentAnswer;
    }

    let newStatus = status[currentQ];

    switch (status[currentQ]) {

      case "not-visited":
        newStatus = hasAnswer
          ? "answered"
          : "not-answered";
        break;

      case "marked":
        newStatus = hasAnswer
          ? "answered-marked"
          : "marked";
        break;

      case "answered-marked":
        newStatus = hasAnswer
          ? "answered-marked"
          : "marked";
        break;

      case "answered":
        newStatus = hasAnswer
          ? "answered"
          : "not-answered";
        break;

      case "not-answered":
        newStatus = hasAnswer
          ? "answered"
          : "not-answered";
        break;

      default:
        break;
    }

    updateQuestionStatus(
      currentQ,
      newStatus,
      answerToSend
    );
    setCurrentQ(index);

    sendCurrentQuestion(index);

  };
  // const loadQuestion = (index) => {
  //   if (!backNavigationRequired && index < currentQ) return;

  //   setStatus((prevStatus) => {
  //     const updated = [...prevStatus];
  //     if (updated[index] === "not-visited") {
  //       updated[index] = "not-answered";
  //     }
  //     return updated;
  //   });
  //   // setCurrentQ(index);
  //   setCurrentQ(index);
  //   sendCurrentQuestion(index);
  // };


  //
  const handleFinalSubmit = () => {
    setSubmitted(true);
    setShowSubmitModal({ open: false, isAuto: false, autoReason: null });
  };

  const checkMandatory = async () => {
    try {
      const res = await axios.post(
        `/exam/check-mandatory/`,
        { exam_employee_id: examData.ExamEmployeeId },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const data = res.data;
      console.log("Mandatory response:", data);

      setUnansweredMandatoryCount(data.unanswered_count || 0);

      return data.unanswered_count;
    } catch (err) {
      console.error("Mandatory check failed:", err);
      return 0;
    }
  };


  // // -------------------- Counts --------------------
  // const answeredCount = status.filter((s) => s === "answered").length;
  // const notVisitedCount = status.filter(s => s === "not-visited").length;
  // const markedCount = status.filter((s) => s === "marked").length;
  // const notAnsweredCount = status.filter((s) => s === "not-answered").length;

  const answeredCount = status.filter(
    (s) => s === "answered" || s === "answered-marked"
  ).length;

  const markedCount = status.filter(
    (s) => s === "marked" || s === "answered-marked"
  ).length;

  const notAnsweredCount = status.filter(
    (s) => s === "not-answered"
  ).length;

  const notVisitedCount = status.filter(
    (s) => s === "not-visited"
  ).length;
  console.log(notVisitedCount, "SSSSSSS");

  // Count answers successfully saved to Mongo
  const mongoSaved = questions.filter((q, index) => {
    return (
      (status[index] === "answered" ||
        status[index] === "answered-marked") &&
      syncStatus[q.questionId] === "mongo"
    );
  }).length;

  // Count answers pending in LocalStorage
  const localSaved = questions.filter((q, index) => {
    return (
      (status[index] === "answered" ||
        status[index] === "answered-marked") &&
      syncStatus[q.questionId] === "local"
    );
  }).length;

  // -------------------- Render --------------------
  if (submitted)
    return (
      <ExamResults
        questions={questions}
        answers={answers}
        status={status}
        usedTime={usedTime}
        exam={exam}
      />
    );



  if (!questions.length)
    return <div className="text-center mt-5">Loading Assessment...</div>;

  const currentQuestion = questions[currentQ];
  console.log(currentQuestion, "fffff")

  const handleCloseConnection = () => {
    setShowCloseConfirm(true);
  };

  const confirmCloseExam = () => {

    if (
      webSocket &&
      webSocket.readyState === WebSocket.OPEN
    ) {
      webSocket.send(
        JSON.stringify({
          action: "exam_closed"
        })
      );
    }

    setShowCloseConfirm(false);

    window.open("", "_self");
    window.close();

    setTimeout(() => {

      navigate("/");

    }, 300);

  };



  return (
    <>


      <div className="exam-portal">


        {/* <div className="pb-5">
          <MainLayout />
        </div> */}
        <ExamHeader title={exam?.Title} timeLeft={timeLeft} />


        <ConnectionLostDialog
          open={connectionLost}
          retrying={retrying}
          onRetry={retryConnection}
          onClose={handleCloseConnection}
        />



        <CloseAssessmentDialog
          open={showCloseConfirm}
          onClose={() => setShowCloseConfirm(false)}
          onConfirm={confirmCloseExam}
        />




        {mongoSyncFailed && (
          <div className="alert alert-danger">
            Unable to save your latest answer.
            Please check your connection.
          </div>
        )}

        <div className="container">
          <div>
            <ExamQuestionCard
              question={currentQuestion}
              questionIndex={currentQ}
              selectedAnswer={answers[currentQ]}
              totalQuestions={questions.length}
              onAnswerSelect={selectOption}
              onPrevious={prevQ}
              onNext={nextQ}
              onMarkReview={markReview}
              onClearResponse={clearResponse}
              showBackButton={backNavigationRequired}
              allowMarkForReview={backNavigationRequired}
            />
          </div>

          <div className="QuestionSubmit">
            <QuestionNavigator
              questions={questions}
              status={status}
              syncStatus={syncStatus}
              currentQuestion={currentQ}
              onQuestionSelect={loadQuestion}
              onSubmit={handleSubmit}
              allowBackNavigation={backNavigationRequired}
            />
            <ProgressOverview
              status={status}
              syncStatus={syncStatus}
              questions={questions}
              allowMarkForReview={backNavigationRequired}
            />
          </div>
        </div>
      </div>
      {violationAlertOpen && <ViolationAlertDialog />}

      <SubmitExamDialog
        open={showSubmitModal.open}
        isAuto={showSubmitModal.isAuto}
        autoReason={showSubmitModal.autoReason}
        onClose={handleCancelSubmit}
        onSubmit={handleFinalSubmit}
        answeredCount={answeredCount}
        notAnsweredCount={notAnsweredCount}
        mongoSavedCount={mongoSaved}
        pendingSyncCount={localSaved}
        markedCount={markedCount}
        showMarkedForReview={backNavigationRequired}
        examId={examData.examId}   // <-- ADD THIS
        examEmployeeId={examData.ExamEmployeeId}
        unansweredMandatoryCount={unansweredMandatoryCount} // ✅ pass prop
        notVisitedCount={notVisitedCount}
      />
    </>
  );
}